module.exports = __webpack_public_path__ + "frontend/images/landlords/landlords-writing-pad-2340a8d5f6283597dac0a987a055893a.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/landlords/landlords-writing-pad.png
// module id = 379
// module chunks = 2